export enum PeriodicityContracts {
    ANNUAL = 'ANNUAL',
    SIX_MONTHLY = 'SIX_MONTHLY',
    QUARTERLY = 'QUARTERLY',
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
    DAILY = 'DAILY'
}

export enum Periodicity {
    ANNUAL = 'ANNUAL',
    SIX_MONTHLY = 'SIX_MONTHLY',
    QUARTERLY = 'QUARTERLY',
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
    DAILY = 'DAILY',
    UNIQUE = 'UNIQUE',
    FIXED_DATE = 'FIXED_DATE',
}

export enum PeriodicityInMonths {
    ANNUAL = 12,
    SIX_MONTHLY = 6,
    QUARTERLY = 3,
    MONTHLY = 1
}